import EditorVMBase from "../../../../Lib/Fs.SmartClient.Client/EditorVMBase";
import { ValidationRules, ValidationController, validateTrigger } from "aurelia-validation";
import FsUtility from "../../../../Lib/Fs.SmartClient.Client/FsUtility";
import { useView, autoinject, Container, computedFrom } from 'aurelia-framework';
import { Router } from 'aurelia-router'
import UserData01 from "../../../Core/Scripts/AppServiceContract/UserData01";
import UserUpdateRequest from "../../../Core/Scripts/AppServiceContract/UserUpdateRequest";
import ManageUserAppService from "../../Scripts/AppServiceContract/ManageUserAppService";
import { fs } from "../../../../Config/FsConfig";

@autoinject
export default class InformationEditorVM extends EditorVMBase {
    Code: string;
    Name: string;
    Email: string;
    Login: string;
    IsActive: boolean;
    IsGroup: boolean;
    Password: string;
    PasswordExpireDate: Date;
    AuthType: any;
    IsCreate: boolean;
    IsEditMode: boolean;
    Id: string;
    ExternalUserId: string;
    Router: Router;
    IsRequirePassword: boolean = false;

    constructor(id) {
        super();
        var self = this;
        this.Router = Container.instance.get(Router);
        self.IsActive = true;

        ValidationRules
            .ensure('Code').required().withMessage('Code is required.')
            .ensure('Name').required().withMessage('Name is required.')
            .ensure('Email').required().withMessage('Email is required.')
            .ensure('Login').required().withMessage('Login is required.')
            .on(this);

        this.IsCreate = true;
        self.Id = id;
        self.Load(id);
    }

    Load(id: string) {
        var self = this;
        if (id != null && id != 'undefined') {
            self.LoadData();
            self.IsCreate = false;
            self.IsEditMode = true;
        } else {
            this.BeginEdit();
        }
    };

    LoadOriginalSource(originalSource: UserData01) {
        this.Code = originalSource.Code;
        this.Name = originalSource.Name;
        this.Email = originalSource.Email;
        this.Login = originalSource.Login;
        this.IsActive = originalSource.IsActive;
        this.AuthType = originalSource.AuthType;
        this.Password = originalSource.Password;
        this.PasswordExpireDate = originalSource.PasswordExpireDate;
        this.IsGroup = originalSource.IsGroup;
        this.ExternalUserId = originalSource.ExternalUserId;
        this.HasOriginalSource = true;
    }

    SaveOriginalSource(originalSource: UserData01) {
        originalSource.Code = $.trim(this.Code);
        originalSource.Name = $.trim(this.Name);
        originalSource.Email = $.trim(this.Email);
        originalSource.Login = $.trim(this.Login);
        originalSource.ExternalUserId = $.trim(this.ExternalUserId);
        originalSource.IsActive = this.IsActive;
        originalSource.AuthType = this.IsGroup;
        originalSource.Password = this.Password;
        originalSource.PasswordExpireDate = this.PasswordExpireDate;

    }

    SaveData() {
        var self = this;
        self.validationController.validate({ object: self }).then(result => {
            if (result.valid) {
                this.Save(null, null);
            }
        });
        ;
    }

    Save(doneCallback: () => void, failCallback: (error) => void) {
        var self = this;

        var request = this.CreateRequest();

        var service = Container.instance.get(ManageUserAppService) as ManageUserAppService;
        if (this.HasOriginalSource) {
            service.Update(request)
                .done((result) => {
                    FsUtility.AlertModal("The item has been updated successfully", 2, 1);
                    if (doneCallback != null) {
                        doneCallback();
                    }
                    window.location.reload();
                }).fail(FsUtility.CommonErrorHandler);
        } else {
            request.IsGroup = false;
            request.AuthType = 0;
            service.Add(request)
                .done((result) => {
                    if (self.IsCreate) {
                        FsUtility.AlertModal("The item has been saved successfully", 2, 1, function (click) {
                            if (click == true) {
                                /*self.Router.navigateToRoute("UserGroupEdit", { id: encode });*/
                                window.location.href = fs.Config.UserDetailUrl + result;
                            }
                        });
                    }
                }).fail(FsUtility.CommonErrorHandler);
        }
    }

    LoadData() {
        var self = this;
        var service = Container.instance.get(ManageUserAppService) as ManageUserAppService;
        service.Load(self.Id)
            .done((result) => {
                self.SetOriginalSource(result);
            }).fail(FsUtility.CommonErrorHandler);
    }

    CreateRequest(): UserUpdateRequest {
        var request = new UserUpdateRequest();
        request.Code = $.trim(this.Code);
        request.Name = $.trim(this.Name);
        request.Email = $.trim(this.Email);
        request.Login = $.trim(this.Login);
        request.ExternalUserId = $.trim(this.ExternalUserId);
        request.IsGroup = this.IsGroup;
        request.Password = $.trim(this.Password);
        request.PasswordExpireDate = this.PasswordExpireDate;
        request.AuthType = this.AuthType;
        request.IsRequirePassword = this.IsRequirePassword;
        request.IsActive = this.IsActive;
        request.UserUID = this.Id;
        return request;
    }

    Cancel() {
        var self = this;
        if (self.IsCreate)
            window.location.href = fs.Config.ClientBaseUrl + "#/Modules/Core/ManageUserPage";
        else {
            this.EndEdit();
            if (this.HasOriginalSource)
                this.LoadOriginalSource(this.OriginalSource);
        }
    }

    @computedFrom('validationController.errors.length', 'Code')
    get CodeErrors() {
        return this.getValidateErrors('Code');
    }

    @computedFrom('validationController.errors.length', 'Name')
    get NameErrors() {
        return this.getValidateErrors('Name');
    }

    @computedFrom('validationController.errors.length', 'Email')
    get EmailErrors() {
        return this.getValidateErrors('Email');
    }

    @computedFrom('validationController.errors.length', 'Login')
    get LoginErrors() {
        return this.getValidateErrors('Login');
    }
    @computedFrom('validationController.errors.length', 'ExternalUserId')
    get ExternalUserIdErrors() {
        return this.getValidateErrors('ExternalUserId');
    }

    @computedFrom('validationController.errors.length', 'Password')
    get PasswordErrors() {
        return this.getValidateErrors('Password');
    }
}
